<template>
  <transition name="modal-fade">
    <div v-if="visible" class="team-inbox-alert-wrapper">
      <div class="modal-backdrop" @click="handleClose"></div>
      <div class="team-inbox-alert-dialog">
        <div class="modal-header">
          <h2 class="modal-title">{{ modalTitle }}</h2>
          <button class="close-btn" @click="handleClose">
            <i class="el-icon-close"></i>
          </button>
        </div>
        <div class="modal-content">
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TeamInboxAlertModalWrapper',
  
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    modalTitle: {
      type: String,
      default: 'Users Without Team Inbox Access'
    }
  },
  
  watch: {
    visible(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  
  beforeDestroy() {
    // Clean up in case component is destroyed while modal is open
    document.body.style.overflow = ''
  },
  
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity 0.3s;
}
.modal-fade-enter, .modal-fade-leave-to {
  opacity: 0;
}

.team-inbox-alert-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.team-inbox-alert-dialog {
  position: relative;
  width: 70%;
  max-width: 1200px;
  height: 95vh;
  max-height: 95vh;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  z-index: 2001;
  overflow: hidden;
  
  .modal-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid #e4e7ed;
    flex-shrink: 0;
    gap: 10px;
    
    .modal-title {
      margin: 0;
      font-size: 20px;
      color: #303133;
      flex: 1;
      text-align: center;
      line-height: 1.4;
      padding-right: 24px; // Space for close button
    }
    
    .close-btn {
      background: none;
      border: none;
      font-size: 20px;
      color: #909399;
      cursor: pointer;
      padding: 0;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      
      &:hover {
        color: #409eff;
      }
    }
  }

  .modal-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;
  }

  @media (max-width: 768px) {
    width: 95%;
    height: 95vh;
    
    .modal-header {
      padding: 15px;
    }
  }
}
</style>